import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class MembershipsService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get list of memberships
     * @returns MembershipList OK.
     * @throws ApiError
     */
    listMemberships({ orgId, projectSlug, after, before, limit = 10, filter, search, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/memberships', path: {
                'orgId': orgId,
            }, query: {
                'projectSlug': projectSlug,
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update membership
     * @returns Membership OK.
     * @throws ApiError
     */
    updateMembership({ orgId, membershipId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/memberships/{membershipId}', path: {
                'orgId': orgId,
                'membershipId': membershipId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete membership
     * Delete user from organization.
     * @returns void
     * @throws ApiError
     */
    deleteMembership({ orgId, membershipId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/memberships/{membershipId}', path: {
                'orgId': orgId,
                'membershipId': membershipId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get all members to display
     * Get all members to display.
     * @returns MemberList OK.
     * @throws ApiError
     */
    listMembers({ orgId, projectSlug, after, before, limit = 10, filter, search, sort = '-id', }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/members', path: {
                'orgId': orgId,
            }, query: {
                'projectSlug': projectSlug,
                'after': after,
                'before': before,
                'limit': limit,
                'filter': filter,
                'search': search,
                'sort': sort,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete membership
     * Delete myself from the organization.
     * @returns void
     * @throws ApiError
     */
    deleteMyselfFromOrganization({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/leave', path: {
                'orgId': orgId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=MembershipsService.js.map